module.exports = __webpack_public_path__ + "static/media/explore.de42583a.svg";